export const API_BASE_URL = "https://renowned-oasis-58a898da10.strapiapp.com/api";

export const API_BASE_AUTH = `${API_BASE_URL}/auth`;

export const API_BASE_LOGIN = `${API_BASE_AUTH}/local`;

export const BASE_IMAGE_URL = `https://renowned-oasis-58a898da10.strapiapp.com`;

export const API_GRAPHQL = `https://renowned-oasis-58a898da10.strapiapp.com/graphql`;